import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../services/api";
import { useAuth } from "../context/AuthContext";

export const useDismissJoinRequest = () => {
  const { user, token } = useAuth();
  const orgId = user?.schoolId || user?.orgId;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (requestId: string) => {
      if (!orgId || !token) {
        throw new Error("Missing organization ID or token");
      }
      return api.users.dismissJoinRequest(orgId, requestId, token);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["joinRequests", orgId] });
    },
  });
};
